module.exports = __webpack_public_path__ + "img/logo.0e16f3a2.png";